<template>
  <div class="c-upload-box-wrapper">
    <div class="c-upload-box">
      <h2 class="c-upload-box__title">{{ title }}</h2>
      
      <file-upload
        ref="upload"
        v-bind:class="cssClass"
        v-bind:drop="drop"
        v-bind:drop-directory="dropDirectory"
        v-bind:input-id="inputId"
        v-bind:multiple="multiple"
        v-bind:name="inputId"
        v-bind:post-action="uploadPostAction"
        v-bind:size="size"
        v-model="files"
        v-on:input-filter="inputFilter"
        v-on:input-file="inputFile"
      >
      </file-upload>

      <template v-if="files.length">  
        <div class="c-upload-box__wrapper" v-for="file in files" v-bind:key="file.id">
          <div class="c-upload-box__file">
            <span class="c-upload-box__name">
              {{ file.name }} ({{ file.size | formatFileSize }})
            </span>
            <span class="c-upload-box__status" v-if="file.error">
              {{ errorMessage(file.error) }}
            </span>
            <span class="c-upload-box__status" v-if="extensionError">
              {{ errorMessage('extension') }}
            </span>
            <span class="c-upload-box__status" v-else-if="file.success">
              Done
            </span>
            <span 
              class="c-upload-box__progress" 
              aria-valuemax="100"
              aria-valuemin="0" 
              v-bind:aria-valuenow="file.progress"
              v-else-if="file.active || file.progress !== '0.00'">
              <span
                class="c-upload-box__progress-bar"
                role="progressbar"
                v-bind:style="{ width: file.progress + '%' }">
                {{ file.progress }}%
              </span>
            </span>
          </div>
          <div class="c-upload-box__actions">
            <button
              class="c-button c-button--brand c-button--text-center"
              type="button"
              v-on:click.prevent="$refs.upload.update(file, {active: true})"
              v-if="!file.success && !extensionError">
              Upload
            </button>
            <button
              class="c-button c-button--brand c-button--text-center"
              type="button"
              v-on:click.prevent="removeUpload(file)"
              v-if="!file.success">
              Reset
            </button>
          </div>
        </div>
      </template>

      <div class="c-upload-box__drag-drop" v-else>
        <span v-if="$refs.upload && $refs.upload.dropActive">You may upload a JPG or PNG file up to 5MB only. Please either drag a file here or</span>
        <span v-else>You may upload a JPG or PNG file up to 5MB only. Please either drag a file here or</span>
        <label class="c-button c-button--link" v-bind:for="inputId">
          Choose file to upload
        </label>
      </div>

    </div>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component';

export default {
  components: {
    FileUpload,
  },
  props: {
    extensions: {
      required: true,
      type: Array,
    },
    title: {
      required: true,
      type: String,
    },
    uploadPostAction: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
      extensionError: false,
      cssClass: 'c-upload-box__input-wrapper',
      drop: true,
      dropDirectory: true,
      files: [],
      inputId: 'fileUpload',
      multiple: false,
      size: 2816 * 2112, // 5MB
    };
  },
  computed: {
    fileTypeRegex() {
      return this.extensions.join('|');
    },
  },
  methods: {
    cancelUpload() {
      this.$refs.upload.active = false;
    },
    errorMessage(key) {
      const errorMessages = {
        abort: "Error: Upload aborted",
        denied: "Error: Network error",
        extension: "Error: Only JPG and PNG file types permitted",
        network: "Error: Please check the file contents to ensure they meet the correct format and try again later",
        server: "Error: Please check the file contents to ensure they meet the correct format and try again later",
        size: "Error: File too large",
        timeout: "Error: Upload timed out",
      };

      return errorMessages[key];
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        const re = new RegExp(`\\.(${this.fileTypeRegex})$`, 'i');
        if (!re.test(newFile.name)) {
          this.extensionError = true;
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        if (newFile.active && !oldFile.active) {
          this.$refs.upload.update(newFile, {active: true, error: '', progress: '0.00'})
        }

        if (newFile.success && !oldFile.success) {
         this.$emit("file-upload", newFile.response);
        }
      }
    },
    removeUpload(file) {
      this.$refs.upload.remove(file);
      this.extensionError = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/report-a-problem/_vue/UploadBox.vue